import React from 'react';
import PropTypes from 'prop-types';
import {Panel} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Tasks, ContainerLoader} from '../';

import * as Actions from 'actions';

class DashboardTasks extends React.Component {

	componentWillMount() {
		this.props.beginInitUsersTasks()
	}

	render() {
		if(!this.props.tasks.tasks)
			<ContainerLoader />

		return (
			<div className='dashboard-tasks-container'>
				<div>
					{(() => {
						if(!this.props.tasks.tasks || this.props.tasks.tasks.length <= 0) {
							return (
								<div className='panel panel-transparent'>
									<div className='panel-heading'>
										<h2 className='panel-title'>Tasks</h2>
									</div>
									<div className='panel-body'>
										<Tasks tasks={this.props.tasks.tasks}/>
									</div>
								</div>
								)
						}
						else {
							return (
								<div>
									<Tasks tasks={this.props.tasks.tasks}/>
								</div>
								)
						}
					})()}
				</div>
			</div>
			)
	}
}

let mapStateToProps = ({tasks}) => ({tasks})

export default connect(mapStateToProps, Actions)(DashboardTasks);


// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboardTasks.js